import { getFlagValue } from "../../utils/ab_tests"
import { isMobile } from "../../utils/breakpoints"
import { displayAd } from "./display"
import { initializeAd } from "./initialize"
import { googletag } from "./shared"
import { adStatuses, getOrCreateStatus } from "./status"

const alongslideAdKeys = [
  "alongslide1",
  "alongslide2",
  "alongslide3",
  "alongslide4",
  "alongslide5",
  "alongslide6",
  "alongslide7",
  "alongslide8",
  "alongslide9",
  "alongslide10",
]

const SWAP_EVERY_X_SLIDES = 4

const hideAndClearAd = (status) => {
  const { slot } = status
  const currentSlotId = slot.getSlotElementId()
  document.getElementById(`${currentSlotId}-container`).classList.add("hidden")
  googletag.destroySlots([slot])
  status.initialized = false
  status.filled = false
}

const clearAlongslideAds = () => {
  alongslideAdKeys.forEach((key) => {
    const mobileStatus = adStatuses.mobile[key]
    const desktopStatus = adStatuses.desktop[key]

    if (mobileStatus && mobileStatus.initialized) {
      hideAndClearAd(mobileStatus)
    }

    if (desktopStatus && desktopStatus.initialized) {
      hideAndClearAd(desktopStatus)
    }
  })
}

const showAlongslideAd = (nextAdIndex) => {
  const containerString = isMobile()
    ? `Slideshow_Page_Alongside_Preso_Mobile_${nextAdIndex}`
    : `Slideshow_Page_Alongside_Preso_Desktop_${nextAdIndex}`
  const group = isMobile() ? "mobile" : "desktop"
  const key = `alongslide${nextAdIndex}`
  const containerId = `alongslide-player-${group}-ad-${nextAdIndex}-container`

  const status = getOrCreateStatus(group, key)
  status.activePath = containerString
  initializeAd(group, key)
  document.getElementById(containerId).classList.remove("hidden")
  displayAd(group, key)
}

const getAlongslideAdIndex = (navigationCount) => {
  const quotient = Math.floor(navigationCount / SWAP_EVERY_X_SLIDES)
  // Take the ones column, to ensure the value is 0-9
  const onesValue = parseInt([...quotient.toString()].reverse()[0], 10)
  // Make the value between 1-10
  return onesValue + 1
}

export const swapAlongslideAdContainer = async (navigationCount) => {
  const isFeatureFlagActive = await getFlagValue("alongslide_ads_flag")
  if (!isFeatureFlagActive) {
    return
  }
  const shouldSwap = navigationCount % SWAP_EVERY_X_SLIDES === 0
  if (shouldSwap) {
    const nextAdIndex = getAlongslideAdIndex(navigationCount)
    clearAlongslideAds()
    showAlongslideAd(nextAdIndex)
  }
}
